
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SortDirection enum
 */
class SortDirection {
  /**
   * Initialize enum with a given value
   * @param {SortDirection|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SortDirection) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SortDirection}
   * @param {!SortDirection} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SortDirection)) {
      throw new TypeError('Instance of SortDirection is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SortDirection}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SortDirection}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SortDirection.ASCENDING.value) {
      return 'ASCENDING'
    }
    if (this.value === SortDirection.DESCENDING.value) {
      return 'DESCENDING'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SortDirection}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SortDirection}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SortDirection} Created enum
   */
  static fromObject (other) {
    return new SortDirection(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SortDirection.ASCENDING = new SortDirection(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SortDirection.DESCENDING = new SortDirection(0 + 1)

export { SortDirection };

/**
 * Fast Binary Encoding SortDirection field model
 */
class FieldModelSortDirection extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSortDirection}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSortDirection}
   * @param {SortDirection=} defaults Default value, defaults is new SortDirection()
   * @returns {!SortDirection} Result value
   */
  get (defaults = new SortDirection()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SortDirection(this.readUInt8(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSortDirection}
   * @param {!SortDirection} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeUInt8(this.fbeOffset, value.value)
  }
}

export { FieldModelSortDirection };
